export default "__VITE_ASSET__7f14213b__"